'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responseError = exports.handleResponse = exports.responseHandlers = undefined;

var _update = require('./update');

var responseHandlersKey = Symbol('responseHandlers');

var responseHandlers = exports.responseHandlers = function responseHandlers(options) {
  return options[responseHandlersKey];
};

var handleResponse = exports.handleResponse = function handleResponse(handler) {
  return (0, _update.push)(responseHandlersKey, handler);
};

var responseError = exports.responseError = function responseError(response, message, code, previousError) {
  return Object.assign(new Error(), response, { message: message, code: code, previousError: previousError });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.161/js/helpers/response.js
// module id = 52
// module chunks = 0